import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isHeCheng: false,
    isHeChengToken: '',
    mhotelId: '',
    mhotelName: '',
    userNumber: '',
    userName: '',
    shotelId: '',
    goldBoothIsShow: false,
    similarHotelIsShow: false,
    nearByIsShow: false,
    businessAreaIsShow: false,
    WeChatAdIsShow: false,
    trafficExpressIsShow: false,
    decorateIsShow: false,
    cpcTrafficExpressIsShow: false,
    intelligentRecommendCanBooking: 0,
    brandAdCanBooking: 0,
    cpmModuleIsShow: false,
    marketActivityIsShow: 0,
    intelligentRecommendIsShow: false,
    jiashuoActivityIsShow: false,
    showCpsModule: false,
    brandAdIsShow: false,
    wallet: true,
    pre_pay: true,
    red_packet_center: true,
    promote_center: true,
    cpc: true,
    cpm: true,
    sail: true,
    my_promote: true,
    recommend: true,
    wechat: true,
    similar: true,
    decorate: true,
    marketing_center: true,
    accurate: true,
    brand: true,
    market: true,
    dkbHome: true,
    commentScore: 400,
    hotelImageCount: 3,
    firstPicture: true,
    mailboxInfo: {
      businessServiceMobile: '95711',
      groupAdministratorMailbox: '',
      invoicingContactMailbox: '',
    },
  },
  getters: {
  },
  mutations: {
    setMailboxInfo(state, val) {
      state.mailboxInfo = val
    },
    setIsHeCheng(state, val) {
      state.isHeCheng = val
    },
    setIsHeChengToken(state, val) {
      state.isHeChengToken = val
    },
    updateState(state: any, { key, value }) {
      if (state.hasOwnProperty(key)) {
        state[key] = value;
      }
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [createPersistedState({
    key: 'dkb-ebook-pc',
    storage: window.sessionStorage,
  })],
})
